module.exports = __webpack_public_path__ + "static/media/denali.941c679d.jpeg";